import Cookies from 'js-cookie';

const startJourneyMutation = `
  mutation startJourney($input: JourneyRequest!) {
    startJourney(input: $input){
        ... on ValidStep {
            sessionId
        }
    }
  }`;

export interface JourneyRequestInputType {
  journeyName: string;
  journeyVersion: string;
  data: { name: string; value: string | number }[];
  meta: { name: string; value: string }[];
}

export interface JourneyResponseOutputType {
  data: { startJourney: { sessionId: string } };
}

export const getStartJourneySessionId = (
  url: string,
  input: JourneyRequestInputType,
): Promise<string> => {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: startJourneyMutation,
      variables: {
        input,
      },
    }),
  })
    .then(res => res.json().then(body => body.data.startJourney.sessionId))
    .catch(error => error);
};

export const handleStartJourney = async (
  journeyRequest: JourneyRequestInputType,
  endpoint: string,
  cookieName: string,
  cookieDomain: string,
  cookieExpiry = 28,
): Promise<void> => {
  const sessionId = await getStartJourneySessionId(endpoint, journeyRequest);

  Cookies.set(cookieName, sessionId, {
    domain: cookieDomain,
    expires: cookieExpiry,
  });
  Cookies.set(cookieName, sessionId, { expires: cookieExpiry });
};
